<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <top-filters />
      <b-card no-body>
        <b-card-header>
          <!-- title and subtitle -->
          <div>
            <b-card-sub-title class="mb-25"> Total </b-card-sub-title>
            <b-card-title class="font-weight-bolder"> $74,382.72 </b-card-title>
          </div>
          <!--/ title and subtitle -->

          <!-- datepicker -->
          <!-- <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
          <!-- datepicker -->
        </b-card-header>
        <b-card-body>
          <vue-apex-charts ref="chartVenta" type="bar" height="350" :options="chartOptions" :series="series" />
          <b-table
            class="position-relative text-center mt-4"
            :hover="true"
            :items="records"
            responsive
            :fields="fields"
            show-empty
            empty-text="No existen"
            @sort-changed="sortChanged"
          >
            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <b-button size="sm" class="" variant="info">
                <span>Detalle</span>
              </b-button>
            </template>
          </b-table>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { $themeColors } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import topFilters from './topFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  components: {
    VueApexCharts,
    flatPickr,
    topFilters
  },
  data() {
    return {
      showLoading: false,
      rangePicker: ['2019-05-01', '2019-05-10'],
      records: [
        {
          id: 1,
          cod_ori: '35352',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 10
        },
        {
          id: 2,
          cod_ori: '265',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 25
        },
        {
          id: 3,
          cod_ori: '2532',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 6
        },
        {
          id: 4,
          cod_ori: '456',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 4
        },
        {
          id: 5,
          cod_ori: '1234',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 0
        },
        {
          id: 6,
          cod_ori: '3466',
          cod_alter: '',
          descripcion: 'PRUEBAAAA',
          marca: 'TOYAMA',
          vehiculo: 'TOYOTA',
          cantidad: 8
        }
      ],
      fields: [
        { key: 'id', label: 'Nº', sortable: false },
        { key: 'cod_ori', label: 'Codigo Original', sortable: true },
        { key: 'cod_alter', label: 'Codigo Alter.', sortable: true },
        { key: 'descripcion', label: 'Descripción', sortable: false },
        { key: 'marca', label: 'Marca', sortable: true },
        { key: 'vehiculo', label: 'Vehiculo', sortable: true },
        { key: 'cantidad', label: 'Cantidad', sortable: true },
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc',
      series: [
        {
          data: []
        }
      ],
      chartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        // colors: $themeColors.info,
        plotOptions: {
          bar: {
            vertical: true,
            barHeight: '30%',
            distributed: true
            // endingShape: 'rounded',
          }
        },
        grid: {
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          // opposite: isRtl,
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    getData() {
      for (let index = 0; index < this.records.length; index++) {
        const element = this.records[index]
        this.chartOptions.xaxis.categories[index] = element.cod_ori
        this.series[0].data[index] = element.cantidad
      }
      this.$refs.chartVenta.updateOptions(this.chartOptions)
      this.$refs.chartVenta.updateSeries(this.series)
    }
  }
}
</script>

<style lang="scss">
.bg-red {
  background-color: #b2a6a6;
  color: #fff;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
